import { useRef, useEffect } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { Checkbox as CheckboxPrimitive } from 'radix-ui';

interface IndeterminateCheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  onCheckedChange?: (checked: CheckboxPrimitive.CheckedState) => void;
  'aria-label'?: string;
  label?: string;
  id?: string;
}

export function IndeterminateCheckbox({
  checked = false,
  indeterminate = false,
  onCheckedChange,
  label,
  id,
  ...props
}: IndeterminateCheckboxProps) {
  const ref = useRef<HTMLButtonElement>(null);
  const checkboxId = id || `checkbox-${Math.random().toString(36).substring(2, 11)}`;

  useEffect(() => {
    if (ref.current) {
      const input = ref.current as HTMLButtonElement & { indeterminate?: boolean };
      if (input.indeterminate !== undefined) {
        input.indeterminate = indeterminate;
      }
    }
  }, [indeterminate]);

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        ref={ref}
        id={checkboxId}
        checked={indeterminate ? 'indeterminate' : checked}
        onCheckedChange={onCheckedChange}
        {...props}
      />
      <Label htmlFor={checkboxId} className="text-sm font-normal cursor-pointer">
        {label}
      </Label>
    </div>
  );
}
